module.exports = __webpack_public_path__ + "assets/img/report-2.89c40ca7.jpg";